import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const legacyJsdKnowledgeRoute: InvariantJiraRoute = {
	name: 'legacy-jsd-knowledge',
	path: '/projects/:projectKey/knowledge/:page?',
};
